import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { FORM_SUPPLIER } from '../../actions/constant'
import { dashboardCommodity } from '../../actions/dashboardAction'
import { Card, CardBody, CardHeader, Row, Col, Table } from 'reactstrap'

let userId = localStorage.getItem('tolaut@userId') || null
let form = localStorage.getItem('tolaut@form') || null

class LatestCommodity extends Component {
  componentDidMount() {
    let data = {}
    if (form === FORM_SUPPLIER) {
      data.supplier_id = userId
    }

    this.props.dashboardCommodity(data)
  }

  changeRupiah(bilangan) {
    var number_string = bilangan.toString(),
      sisa = number_string.length % 3,
      rupiah = number_string.substr(0, sisa),
      ribuan = number_string.substr(sisa).match(/\d{3}/g);
    if (ribuan) {
      let separator = sisa ? '.' : '';
      rupiah += separator + ribuan.join('.');
    }
    return rupiah
  }

  render() {
    if (this.props.dashboardCommodityIsLoading) {
      return (
        <div>
          <p>Loading ..... </p>
        </div>
      )
    }

    if (this.props.dashboardCommodityHasError) {
      return (
        <div>
          <p>Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi dengan internet</p>
        </div>
      )
    }

    return (
      <div>
        <Row>
          <Col xs="12" sm="12" md="12" lg="12">
            <Card>
              <CardHeader className="text-center">
                <h5>Komoditi Terbaru</h5>
              </CardHeader>
              <CardBody className="p-0">
                {this.props.dashboardCommodityIsSuccess &&
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th className="text-center align-top">Kode Barang</th>
                        <th className="text-center align-top">Nama Barang</th>
                        <th className="text-center align-top">Jenis Barang</th>
                        <th className="text-center align-top">Harga Satuan</th>
                        <th className="text-center align-top">Min. Order</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.dashboardCommodityData.data.map((item, idx) => (
                        <tr key={idx}>
                          <td className="text-center align-top">
                            <Link to={"commodity/view/" + item.id}>{item.kode_barang}</Link>
                          </td>
                          <td className="text-center align-top">{item.nama_barang}</td>
                          <td className="text-center align-top">{item.jenis_barang}</td>
                          <td className="text-center align-top">Rp.{this.changeRupiah(item.harga_satuan)}</td>
                          <td className="text-center align-top">{item.minimum_order}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                }
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

LatestCommodity.propTypes = {
  dashboardCommodityIsSuccess: PropTypes.bool.isRequired,
  dashboardCommodityHasError: PropTypes.bool.isRequired,
  dashboardCommodityIsLoading: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => {
  return {
    dashboardCommodityData: state.dashboard.dashboardCommodityData,
    dashboardCommodityIsSuccess: state.dashboard.dashboardCommoditySuccess,
    dashboardCommodityHasError: state.dashboard.dashboardCommodityError,
    dashboardCommodityIsLoading: state.dashboard.dashboardCommodityLoading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dashboardCommodity: (data) => dispatch(dashboardCommodity(data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LatestCommodity)